import Vue from 'vue';

export default {

  name: 'event-column',

  props: {
    event: {}
  },

  computed: {
    currentDate: function () {
      return new Date();
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/events/EventColumn/EventColumn.js